import styled from 'styled-components';
import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const SelectedFiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const FilterDivider = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(3)};
  justify-content: space-between;
  margin-bottom: ${size(2)};
  ${theme.screens.LtMd} {
    display: block;
  }
`;

export const ProductViewWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: ${size(3)};
`;

export const ProductGridWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  gap: ${size(3)};
  ${theme.screens.LtMd} {
    justify-content: space-between;
    flex-direction: row-reverse;
  }
  padding-bottom: 1px;
`;

export const LeadTimeWrapper = styled.div`
  margin-bottom: ${size(2)};
  ${theme.screens.LtSm} {
    margin-bottom: ${size(3)};
  }
`;
